import React from 'react';
import { AnimatedSection } from './AnimatedSection';
import { CheckCircle2 } from 'lucide-react';
import { useLanguage } from './LanguageContext';
export function Solution() {
  const {
    t
  } = useLanguage();
  return <AnimatedSection data-id="element-197">
      <div className="text-center mb-16" data-id="element-198">
        <h2 className="text-4xl md:text-5xl font-oswald font-bold mb-6" data-id="element-199">
          {t.solution.title1}
          <span className="text-barber-gold" data-id="element-200">{t.solution.title2}</span>
        </h2>
        <p className="text-xl text-gray-400 max-w-2xl mx-auto" data-id="element-201">
          {t.solution.subtitle}
        </p>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-5xl mx-auto" data-id="element-202">
        {t.solution.benefits.map((benefit, index) => <div key={index} className="bg-barber-dark p-6 rounded-lg border border-white/5 flex items-center gap-4 hover:border-barber-gold/30 transition-colors" data-id="element-203">
            <CheckCircle2 className="text-green-500 shrink-0" size={24} data-id="element-204" />
            <span className="text-lg font-medium" data-id="element-205">{benefit}</span>
          </div>)}
      </div>
    </AnimatedSection>;
}